import { capitalize } from "client/utils/capitalize";
import { translateFunc } from "client/utils/translateFunc";
import { DeleteIcon } from "components/common/Icons/DeleteIcon";
import { deleteTextBox } from "store/features/memeGenerator/actions";
import { useAppDispatch } from "store/store";
import { Option } from "../Option/Option";

interface DeleteProps {
    textBoxId: string;
}

export const Delete = ({ textBoxId }: DeleteProps) => {
    const dispatch = useAppDispatch();
    function onClick() {
        dispatch(deleteTextBox(textBoxId));
    }
    return (
        <Option
            icon={<DeleteIcon fill="var(--red-500)" />}
            text={capitalize(translateFunc("delete"))}
            onClick={onClick}
        />
    );
};
